import { FilterBar } from '@/components/filters/FilterBar';
import { SearchInput } from '@/components/filters/SearchInput';
import { DateRangePicker } from '@/components/filters/DateRangePicker';
import { Button } from '@/components/ui/Button';
import { useAdminUsers } from '@/hooks/useAdminUsers';
import { Download } from 'lucide-react';
import { useState } from 'react';
import { UsersTable } from '../components/UsersTable';
import { exportToExcel } from '@/utils/export';

export function UsersListPage() {
  const [search, setSearch] = useState('');
  const [dateFrom, setDateFrom] = useState<string | null>(null);
  const [dateTo, setDateTo] = useState<string | null>(null);
  const [page] = useState(1);

  const { data, isLoading } = useAdminUsers({ search, page, limit: 25, dateFrom: dateFrom || undefined, dateTo: dateTo || undefined });
  const users = data?.data || [];
  const totalItems = data?.pagination?.totalItems ?? 0;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Utilisateurs</h1>
          <p className="text-sm text-neutral-500">
            {totalItems} utilisateurs au total
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          icon={<Download className="h-4 w-4" />}
          onClick={() => exportToExcel(users, 'utilisateurs')}
        >
          Exporter
        </Button>
      </div>

      <FilterBar>
        <div className="w-72">
          <SearchInput value={search} onChange={setSearch} placeholder="Rechercher un utilisateur..." />
        </div>
        <DateRangePicker
          dateFrom={dateFrom}
          dateTo={dateTo}
          onChange={(from, to) => { setDateFrom(from); setDateTo(to); }}
        />
      </FilterBar>

      <UsersTable data={users} loading={isLoading} />
    </div>
  );
}
